import { Button } from '$uikit';
import './SponsorCongratulations.sass';

import Lottie from 'lottie-react';
import animation from 'assets/lottie/sponsorFollow.json';

import React, { FC, useCallback, useRef, useState } from 'react';
import cn from 'classnames';
import { Portal } from '$uikit/Portal/Portal';
import { balancePayActions } from '$store/balancePay';
import { useDispatch } from 'react-redux';
import { RESOLVE } from '$shared/constants/pages';
import { useGetAuthorId } from '$utils/useGetAuthorId';
import { useRouter } from 'react-router5';
import { useCurrentLang, useTranslator, useUserInfo } from '$hooks';
import { inclineUserName } from '$utils';
import { balanceActions } from '$store/balance';

interface AnimationSegments {
  [key: string]: [number, number];
}

const animationSegments: AnimationSegments = {
  opened: [66, 333],
  closed: [333, 500],
};

export const SponsorCongratulations: FC = () => {
  const [isClosing, setIsClosing] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const authorId = useGetAuthorId();
  const author = useUserInfo(authorId);
  const currentLang = useCurrentLang();

  const t = useTranslator();

  const lottieRef = useRef<any>(null);
  const isComplete = useRef<boolean>(false);

  const onComplete = useCallback(() => {
    isComplete.current = true;
  }, []);

  const onClose = useCallback(
    (event) => {
      event.stopPropagation();
      if (lottieRef.current && isComplete.current && !isClosing) {
        lottieRef.current.playSegments(animationSegments.closed);
        setIsClosing(true);
        router.navigate(RESOLVE, { domain: 'id' + authorId }, { tab: 'sponsored' });
        setTimeout(() => {
          dispatch(balancePayActions.close());
          dispatch(
            balanceActions.setTopUpActive({
              topUpActive: false,
            }),
          );
        }, 600);
      }
    },
    [lottieRef.current, authorId],
  );

  return (
    <Portal>
      <div
        onClick={onClose}
        className={cn('SponsorCongratulations', { closing: isClosing })}
      >
        <div className={'SponsorCongratulations__content'}>
          <h3 className={'SponsorCongratulations__header'}>
            {t('sponsorCongratulations_title')}
          </h3>
          <p className={'SponsorCongratulations__body'}>
            {author !== undefined &&
              t('sponsorCongratulations_support', {
                name: inclineUserName(author, 'genitive', currentLang.key).first,
              })}
          </p>
        </div>
        <Button className={'SponsorCongratulations__button'} onClick={onClose}>
          {t('sponsorCongratulations_dive')}
        </Button>
        <Lottie
          onComplete={onComplete}
          className={'SponsorCongratulations__animation'}
          lottieRef={lottieRef}
          animationData={animation}
          loop={false}
          initialSegment={animationSegments.opened}
        />
      </div>
    </Portal>
  );
};